module.exports = __webpack_public_path__ + "assets/img/ellipse-white.7bea4464.svg";